import React from 'react';
import { Box, Text } from '@chakra-ui/react';

const HomeSection = () => {
  return (
    <Box
      w="full"
      h={['100%',"70vh"]}
      display="flex"
      mt={['2rem','0']}
      p='2rem'
      alignItems="center"
      bg={['#F5F8FF','']}
      justifyContent="center"
      flexDirection="column"
    >
      <Text
        fontSize={['1.5rem', '2rem', '2.5rem', '3rem']}
        fontWeight="500"
        fontFamily='Duplicate Sans'
        textAlign="center"
        noOfLines={['none', 'none', 'none', '2']}
      >
        Access the Funds without <br />
        the Card
      </Text>
      <Text
        fontSize={['.75rem', '1.05rem']}
        mt="1rem"
        noOfLines='3'
        lineHeight='20px'
        textAlign="center"fontFamily='Work Sans'
        color={['#1F1F29',"#445368"]}
      >
        More than creating a seamless platform for you to access your funds,
        we are bringing to you cardless transactions, the redefined way .
      </Text>
    </Box>
  );
};

export default HomeSection;
